<template>
  <GridContainer class="footer-corporate">
    <a
      class="link link--unstyled link--external footer-corporate__copyright footer-corporate__link"
      href="https://www.telekom.de/ueber-das-unternehmen"
      rel="noopener"
      target="_blank"
    >
      &copy; Telekom Deutschland GmbH
      <span class="sr-only">(Der Link wird in einem neuen Tab geöffnet)</span>
    </a>

    <ul class="footer-corporate__list">
      <template
        v-for="(item, index) in navList"
        :key="index"
      >
        <li class="footer-corporate__list-item">
          <a
            :href="item.url"
            class="link link--unstyled link--external footer-corporate__link"
            rel="noopener"
            target="_blank"
            :data-testid="getDataId(item)"
          >
            <SvgIcon
              v-if="item.icon"
              :image="item.icon"
              class="footer-corporate__link-icon"
            />
            {{ item.label }}
            <span class="sr-only">(Der Link wird in einem neuen Tab geöffnet)</span>
          </a>
        </li>
      </template>
    </ul>
  </GridContainer>
</template>

<script setup lang="ts">
import { GridContainer } from '@i22team/td-longtail-vue-components';
import privacy from '~/assets/images/privacy.svg';

const navList = [
  {
    label: 'Impressum',
    url: 'https://www.telekom.de/impressum',
  },
  {
    icon: privacy,
    label: 'Datenschutz',
    url: 'https://www.telekom.de/ueber-das-unternehmen/datenschutz',
  },
  {
    label: 'Barrierefreiheit',
    url: 'https://www.telekom.de/ueber-das-unternehmen/barrierefreiheit',
  },
  {
    label: 'AGB',
    url: 'https://www.telekom.de/agb',
  },
  {
    label: 'Produktinformationsblatt',
    url: 'https://www.telekom.de/produktinformationsblatt',
  },
  {
    label: 'Verbraucherinformationen',
    url: 'https://www.telekom.de/ueber-das-unternehmen/verbraucherinformationen',
  },
  {
    label: 'Jugendschutz',
    url: 'https://www.telekom.de/ueber-das-unternehmen/jugendschutz',
  },
  {
    label: 'Hinweise ElektroG/BattG',
    url: 'https://www.telekom.de/ueber-das-unternehmen/hinweise-elektrogeraete-batterie-rueckgabe',
  },
];

const getDataId = (navItem) => {
  const lowercaseLabel = navItem?.label?.toLowerCase();
  return lowercaseLabel && `corporate-footer-${lowercaseLabel}-link`;
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.footer-corporate {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-start;
  padding-inline: $grid-base;
  padding-bottom: $grid-base * 3;
  font-size: 15px;
  line-height: 1.2;
  max-width: $max-navbar-width + $grid-base * 4;

  @include mq($mq-sm) {
    padding-bottom: $grid-base * 4;
  }

  @include mq($mq-md) {
    padding-inline: $grid-base * 2;
  }

  @include mq($mq-lg) {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }

  &__list {
    display: flex;
    flex-direction: column;
    @include mq($mq-sm) {
      flex-wrap: wrap;
      flex-direction: row;
      grid-gap: 0 $grid-base * 2;
    }

    &-item {
      list-style: none;
      padding: 3px 0;
    }
  }

  &__link {
    &-icon {
      width: 1em;
      height: 1em;
    }
  }

  &__copyright {
    @include mq($mq-sm) {
      margin-bottom: 0.5rem;
    }

    @include mq($mq-lg) {
      margin-bottom: 0;
      white-space: nowrap;
      margin-right: $grid-base * 2;
    }
  }
}
</style>
